import React from 'react';
import {Plugins, Component, ExpressionPath} from '@packages/systems/wfdl';
import {
  type ContextualExpression,
  ContextualExpressions,
  stripAll,
} from '@packages/utilities/contextual-expression';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {reportBug} from '@packages/utilities/reporter';
import {findComponentPath} from '../utils';
import {qualify} from '@packages/systems/wfdl-Qualified';
import {createDevLinkRootAlias} from '@packages/utilities/integrated-types';

const {getIn} = ContextualExpressions;

const FormFileUploadChildrenType = createDevLinkRootAlias({
  params: ['extraAtomFields'],
  fields: {children: TListOfElement},
  render: function RenderFormFileUploadChildren({
    expr,
    dispatch,
  }: {
    expr: ContextualExpression;
    dispatch: (arg1?: any) => void;
  }) {
    const strippedExpr = stripAll(expr);
    const fileUploadInputPath =
      findComponentPath(
        strippedExpr,
        qualify(Plugins.name('Form'), Component.name('FormFileUploadInput'))
      ) ||
      findComponentPath(
        strippedExpr,
        qualify(
          Plugins.name('Users'),
          Component.name('UserFormFileUploadInput')
        )
      );

    if (!fileUploadInputPath) {
      reportBug(
        'FormFileUploadInputNotFoundInFormWrapper',
        'Form File Upload Input has not been found in Form Wrapper',
        {
          expr: strippedExpr,
          team: 'platform',
          ticket: 'https://webflow.atlassian.net/browse/PLAT-1067',
        }
      );
      return null;
    }

    const path = [
      ...fileUploadInputPath,
      {in: 'Element'},
    ] satisfies ExpressionPath;
    const fileUploadInputExpr = getIn(expr, path);
    const onChange = extendExpressionEditorActionAtPath(dispatch)(path);

    return fileUploadInputExpr ? (
      <ExpressionEditor expression={fileUploadInputExpr} dispatch={onChange} />
    ) : null;
  },
});

export default FormFileUploadChildrenType;
